(() => {
  // R24: mount before paint, keep one position and handle late app renders.
  const stateUpdaters = new WeakMap();
  let savedFormWrapper = null;
  let selectedChoice = '';
  let scheduled = false;
  const initialStyle = document.createElement('style');
  initialStyle.id = 'dsv-combine-loading-style';
  initialStyle.textContent = `
    #dsv-combine-order:not([data-dsv-initialized="true"]) { display:none !important; }
    #dsv-existing-order-form-wrapper { scroll-margin:16px; }
  `;
  document.head.appendChild(initialStyle);

  function initDSV() {
    const box = document.querySelector('#dsv-combine-order');

    const formWrapper = document.querySelector(
      '#dsv-existing-order-form-wrapper'
    ) || savedFormWrapper;
    if (formWrapper) savedFormWrapper = formWrapper;

    const cartContent = document.querySelector(
      '[data-essential-cart-element="cart-drawer-content"]'
    );

    const cartFooter = document.querySelector(
      '[data-essential-cart-element="cart-drawer-footer"]'
    );

    if (!box || !formWrapper || !cartContent || !cartFooter) {
      return false;
    }

    let checkoutButton =
      cartFooter.querySelector('[name="checkout"]') ||
      cartFooter.querySelector('a[href*="/checkout"]');

    if (!checkoutButton) return false;
    // Alleen tonen voor het actieve winkelland Nederland of België.
const countryCode = String(
  window.Shopify && window.Shopify.country || ''
).toUpperCase();

const showCombineOrder =
  countryCode === 'NL' || countryCode === 'BE';

if (!showCombineOrder) {
  box.style.setProperty('display', 'none', 'important');
  formWrapper.style.setProperty('display', 'none', 'important');

  // Stop vóór de code die de afrekenknop blokkeert.
  return true;
}

    // Voorkom dubbele initialisatie
    if (box.dataset.dsvInitialized === 'true') {
      const update = stateUpdaters.get(box);
      if (update) update();
      return true;
    }
    // An app redraw can recreate the custom block. Keep the user's choice.
    if (selectedChoice) {
      const radio = box.querySelector(`input[name="dsv-combine-choice"][value="${selectedChoice}"]`);
      if (radio) radio.checked = true;
    }

    box.dataset.dsvInitialized = 'true';

    // -----------------------------------------
    // Zet ons blok in Essential's eigen
    // scrollbare cart-content
    // -----------------------------------------

    cartContent.appendChild(box);
    box.appendChild(formWrapper);

    // -----------------------------------------
    // Hoofdblok
    // -----------------------------------------

    box.style.cssText = `
      margin: 10px 14px 14px;
      padding: 12px 14px;
      background: #f7f7f7;
      border: 1px solid #dedede;
      border-radius: 9px;
      font-size: 14px;
      line-height: 1.45;
      color: #303030;
      flex: 0 0 auto;
      box-sizing: border-box;
      z-index: 10;
    `;

    const heading = box.querySelector(
      '.dsv-combine-heading'
    );

    if (heading) {
      heading.style.cssText = `
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 4px;
      `;

      const title = heading.querySelector('strong');
      const subtitle = heading.querySelector('span');

      if (title) {
        title.style.cssText = `
          font-size: 15px;
          font-weight: 700;
        `;
      }

      if (subtitle) {
        subtitle.style.cssText = `
          font-size: 13px;
          color: #666;
        `;
      }
    }

    // -----------------------------------------
    // Keuzes
    // -----------------------------------------

    box
      .querySelectorAll('.dsv-combine-option')
      .forEach((option) => {
        option.style.cssText = `
          display: flex;
          align-items: center;
          gap: 8px;
          margin: 2px 0;
          line-height: 1.25;
          cursor: pointer;
        `;
      });

    box
      .querySelectorAll(
        'input[name="dsv-combine-choice"]'
      )
      .forEach((radio) => {
        radio.style.cssText = `
          margin: 0;
          flex: 0 0 auto;
        `;
      });

    // -----------------------------------------
    // Informatieknop
    // -----------------------------------------

    const infoButton = box.querySelector(
      '#dsv-combine-info-button'
    );

    const infoBox = box.querySelector(
      '#dsv-combine-info'
    );

    if (infoButton) {
      infoButton.style.cssText = `
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 15px;
        width: 15px;
        height: 15px;
        min-width: 15px;
        min-height: 15px;
        margin: -6px 0 0 -3px;
        padding: 0;
        border: 1px solid #777;
        border-radius: 50%;
        background: transparent;
        box-shadow: none;
        color: #555;
        font-size: 10px;
        font-weight: 700;
        line-height: 1;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
      `;
    }

    if (infoBox) {
      infoBox.style.cssText = `
        display: none;
        margin-top: 10px;
        padding: 12px;
        background: #fff;
        border: 1px solid #dedede;
        border-radius: 7px;
        font-size: 13px;
        line-height: 1.45;
      `;

      infoBox.querySelectorAll('p').forEach((p) => {
        p.style.margin = '7px 0 0';
      });
    }

    if (infoButton && infoBox) {
      infoButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const isOpen =
          infoBox.style.display === 'block';

        infoBox.style.display =
          isOpen ? 'none' : 'block';

        infoButton.setAttribute(
          'aria-expanded',
          isOpen ? 'false' : 'true'
        );
      });
    }

    // -----------------------------------------
    // Formulier
    // -----------------------------------------

    formWrapper.style.cssText = `
      display: none;
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #dedede;
    `;

    const intro = formWrapper.querySelector(
      '.dsv-form-intro'
    );

    if (intro) {
      intro.style.marginBottom = '12px';

      const introTitle = intro.querySelector('strong');
      const introText = intro.querySelector('p');

      if (introTitle) {
        introTitle.style.cssText = `
          display: block;
          font-size: 15px;
          margin-bottom: 4px;
        `;
      }

      if (introText) {
        introText.style.cssText = `
          margin: 0;
          font-size: 13px;
          color: #555;
        `;
      }
    }

    formWrapper
      .querySelectorAll('.dsv-existing-order-field')
      .forEach((field) => {
        field.style.marginBottom = '10px';

        const label = field.querySelector('label');

        const input = field.querySelector(
          'input, textarea'
        );

        if (label) {
          label.style.cssText = `
            display: block;
            margin-bottom: 4px;
            font-size: 13px;
            font-weight: 600;
          `;
        }

        if (input) {
          input.style.cssText = `
            display: block;
            width: 100%;
            box-sizing: border-box;
            padding: 10px 11px;
            border: 1px solid #d7d7d7;
            border-radius: 6px;
            background: #fff;
            font: inherit;
            font-size: 14px;
          `;
        }
      });

    const warning = formWrapper.querySelector(
      '.dsv-manual-warning'
    );

    if (warning) {
      warning.style.cssText = `
        margin: 3px 0 11px;
        padding: 9px 10px;
        background: #fff8e5;
        border-radius: 6px;
        font-size: 12px;
        line-height: 1.4;
      `;
    }

    const submitButton = formWrapper.querySelector(
      '#dsv-existing-order-submit'
    );

    // -----------------------------------------
// Winkelwagenproducten meesturen
// -----------------------------------------

const actualForm = formWrapper.querySelector('form');

if (actualForm && actualForm.dataset.dsvSubmitBound !== 'true') {
  actualForm.dataset.dsvSubmitBound = 'true';
  let cartProductsField = actualForm.querySelector(
    '[name="contact[Producten uit winkelwagen]"]'
  );

  if (!cartProductsField) {
    cartProductsField = document.createElement('textarea');

    cartProductsField.name =
      'contact[Producten uit winkelwagen]';

    cartProductsField.style.display = 'none';

    actualForm.appendChild(cartProductsField);
  }

  actualForm.addEventListener('submit', async (event) => {
    /*
     * Eerst tegenhouden zodat we de actuele winkelwagen
     * kunnen ophalen. Daarna sturen we het formulier
     * op de normale Shopify-manier door.
     */
    if (actualForm.dataset.dsvCartAdded === 'true') {
      return;
    }

    event.preventDefault();

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Even geduld...';
    }

    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Winkelwagen kon niet worden opgehaald.');
      }

      const cart = await response.json();

      const productLines = cart.items.map((item) => {
        const productUrl =
          window.location.origin + item.url;

        const sku =
          item.sku && item.sku.trim()
            ? item.sku
            : 'Geen SKU';

        let text = '';

        text += `${item.quantity}× ${item.product_title}\n`;
        text += `SKU: ${sku}\n`;
        text += `Link: ${productUrl}`;

        if (
          item.variant_title &&
          item.variant_title !== 'Default Title'
        ) {
          text += `\nVariant: ${item.variant_title}`;
        }

        return text;
      });

      cartProductsField.value =
        productLines.join('\n\n');

      actualForm.dataset.dsvCartAdded = 'true';

      actualForm.requestSubmit();
    } catch (error) {
      console.error(
        'DSV winkelwagen toevoegen mislukt:',
        error
      );

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = 'Verzoek versturen';
      }

      alert(
        'Het is niet gelukt om je winkelwagen aan het verzoek toe te voegen. Probeer het opnieuw.'
      );
    }
  });
}

    if (submitButton) {
      submitButton.style.cssText = `
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding: 12px 16px;
        border: 0;
        border-radius: 7px;
        background: #000;
        color: #fff;
        font: inherit;
        font-weight: 600;
        cursor: pointer;
      `;
    }

    // -----------------------------------------
    // Melding boven checkoutknop
    // -----------------------------------------

    const checkoutNotice = document.querySelector('#dsv-checkout-notice') || document.createElement('div');

    checkoutNotice.id = 'dsv-checkout-notice';

    checkoutNotice.textContent =
      '↑ Kies hierboven eerst hoe je verder wilt';

    checkoutNotice.style.cssText = `
      margin: 0 0 8px;
      padding: 8px 10px;
      background: #fff8e5;
      border: 1px solid #eadcae;
      border-radius: 6px;
      color: #303030;
      font-size: 13px;
      font-weight: 600;
      line-height: 1.3;
      text-align: center;
    `;

    checkoutButton.parentElement.insertBefore(
      checkoutNotice,
      checkoutButton
    );

    // -----------------------------------------
    // Sticky / normale positie
    // -----------------------------------------

    // Always part of the scrollable content: no jump from sticky to relative.
    function makeBoxNormal() {
      box.style.position = 'relative';
      box.style.bottom = 'auto';
      box.style.zIndex = '10';
      box.style.boxShadow = 'none';
    }

    // -----------------------------------------
    // Keuzelogica
    // -----------------------------------------

    const radios = box.querySelectorAll(
      'input[name="dsv-combine-choice"]'
    );

    function updateState() {
      // Essential can replace its checkout button without replacing our block.
      const currentFooter = document.querySelector('[data-essential-cart-element="cart-drawer-footer"]');
      const currentButton = currentFooter?.querySelector('[name="checkout"]') || currentFooter?.querySelector('a[href*="/checkout"]');
      if (!currentButton) return;
      checkoutButton = currentButton;
      if (checkoutNotice.parentElement !== checkoutButton.parentElement) {
        checkoutButton.parentElement.insertBefore(checkoutNotice, checkoutButton);
      }
      const selected = box.querySelector(
        'input[name="dsv-combine-choice"]:checked'
      );

      selectedChoice = selected ? selected.value : '';

      // ---------------------------------------
      // Nog niets gekozen
      // ---------------------------------------

      if (!selected) {
        formWrapper.style.display = 'none';

        makeBoxNormal();

        checkoutNotice.style.display = 'block';

        // Laat Essential zelf de knoptekst en prijs beheren.
        checkoutButton.style.display = '';
        checkoutButton.style.opacity = '0.55';
        checkoutButton.style.pointerEvents = '';

        return;
      }

      // ---------------------------------------
      // Nieuwe bestelling plaatsen
      // ---------------------------------------

      if (selected.value === 'no') {
        formWrapper.style.display = 'none';

        makeBoxNormal();

        checkoutNotice.style.display = 'none';

        checkoutButton.style.display = '';
        checkoutButton.style.opacity = '';
        checkoutButton.style.pointerEvents = '';

        return;
      }

      // ---------------------------------------
      // Toevoegen aan bestaande bestelling
      // ---------------------------------------

      if (selected.value === 'yes') {
        // Het lange formulier moet gewoon
        // onderdeel zijn van de scrollbare inhoud.
        makeBoxNormal();

        const wasOpen = formWrapper.style.display === 'block';
        formWrapper.style.display = 'block';
        if (!wasOpen && typeof formWrapper.animate === 'function' && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
          formWrapper.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
        }

        checkoutNotice.style.display = 'none';

        // Geen nieuwe bestelling plaatsen
        checkoutButton.style.display = 'none';

        // Keep the drawer's scroll position; do not scroll the whole page.
      }
    }

    radios.forEach((radio) => {
      radio.addEventListener(
        'change',
        updateState
      );
    });

    stateUpdaters.set(box, updateState);
    updateState();

    return true;
  }

  // No ten-second cutoff: the drawer may load only after a first cart action.
  // Observe structural changes only; our style changes cannot cause a loop.
  const relevant = '[data-essential-cart-element], #dsv-combine-order, #dsv-existing-order-form-wrapper, .essential-cart-drawer-container';
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    Promise.resolve().then(() => {
      scheduled = false;
      initDSV();
    });
  }
  const appObserver = new MutationObserver(records => {
    const changed = records.some(record =>
      record.target instanceof Element && record.target.closest('.essential-cart-drawer-container') ||
      [...record.addedNodes].some(node => node instanceof Element &&
        (node.matches(relevant) || node.querySelector(relevant)))
    );
    if (changed) scheduleInit();
  });
  appObserver.observe(document.body, { childList: true, subtree: true });
  initDSV();
})();
/* =========================================================
   DSV - SUCCESMELDING BESTAANDE BESTELLING
   ========================================================= */

(() => {
  const params = new URLSearchParams(window.location.search);

  if (params.get('contact_posted') !== 'true') {
    return;
  }

  if (window.location.hash !== '#dsv-existing-order-form') {
    return;
  }

  // -------------------------------------------------------
  // Winkelwagen legen
  // Alleen nadat Shopify het verzoek succesvol heeft verwerkt
  // -------------------------------------------------------

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  }).catch((error) => {
    console.error('DSV winkelwagen legen mislukt:', error);
  });

  // -------------------------------------------------------
  // Achtergrond
  // -------------------------------------------------------

  const overlay = document.createElement('div');

  overlay.id = 'dsv-existing-order-success-overlay';

  overlay.style.cssText = `
    position: fixed;
    inset: 0;
    z-index: 999998;
    background: rgba(0, 0, 0, 0.35);
  `;

  // -------------------------------------------------------
  // Succesmelding
  // -------------------------------------------------------

  const successBox = document.createElement('div');

  successBox.id = 'dsv-existing-order-success';

  successBox.innerHTML = `
    <button
      type="button"
      id="dsv-success-close"
      aria-label="Sluiten"
      style="
        position: absolute;
        top: 10px;
        right: 12px;
        width: 32px;
        height: 32px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #555;
        font-size: 25px;
        font-weight: 400;
        line-height: 32px;
        cursor: pointer;
      "
    >×</button>

    <div style="
      font-size: 34px;
      line-height: 1;
      margin-bottom: 12px;
    ">✓</div>

    <strong style="
      display: block;
      font-size: 20px;
      margin-bottom: 8px;
    ">
      Verzoek ontvangen!
    </strong>

    <p style="
      margin: 0 0 10px;
      line-height: 1.5;
    ">
      We hebben je verzoek om producten toe te voegen aan
      je bestaande bestelling ontvangen.
    </p>

    <p style="
      margin: 0 0 10px;
      line-height: 1.5;
    ">
      We verwerken je verzoek handmatig. Zodra de producten
      zijn toegevoegd, ontvang je van ons een aangepast
      betaalverzoek.
    </p>

    <p style="
      margin: 0 0 20px;
      font-size: 13px;
      line-height: 1.45;
      opacity: 0.8;
    ">
      Let op: de producten zijn pas gereserveerd nadat wij
      je verzoek hebben verwerkt.
    </p>

    <button
      type="button"
      id="dsv-success-continue"
      style="
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding: 12px 16px;
        border: 0;
        border-radius: 7px;
        background: #000;
        color: #fff;
        font: inherit;
        font-weight: 600;
        cursor: pointer;
      "
    >
      Verder winkelen
    </button>
  `;

  successBox.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999999;
    width: calc(100% - 40px);
    max-width: 480px;
    box-sizing: border-box;
    padding: 28px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.20);
    color: #303030;
    text-align: center;
  `;

  document.body.appendChild(overlay);
  document.body.appendChild(successBox);

  // -------------------------------------------------------
  // Melding sluiten
  // -------------------------------------------------------

  function closeSuccessMessage() {
    successBox.remove();
    overlay.remove();
  }

  const closeButton =
    document.getElementById('dsv-success-close');

  const continueButton =
    document.getElementById('dsv-success-continue');

  if (closeButton) {
    closeButton.addEventListener(
      'click',
      closeSuccessMessage
    );
  }

  if (continueButton) {
    continueButton.addEventListener(
      'click',
      closeSuccessMessage
    );
  }

  // Klik op donkere achtergrond = ook sluiten
  overlay.addEventListener(
    'click',
    closeSuccessMessage
  );

  // Escape = ook sluiten
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSuccessMessage();
    }
  });

  // -------------------------------------------------------
  // Succesparameter uit URL verwijderen
  // zodat melding niet opnieuw verschijnt bij refresh
  // -------------------------------------------------------

  const cleanUrl = window.location.pathname;

  window.history.replaceState(
    {},
    document.title,
    cleanUrl
  );
})();